const CONSTANTS = module.exports = {};


CONSTANTS.CHAT_PROVIDERS = {
    INTERCOM: 'intercom',
    ZENDESK_HE: 'zendesk_he',
    ZENDESK_EN: 'zendesk_en',
};